<app-retail-store-form-wrapper
  data-testid="retail-store-add-container"
  #formWrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-retail-store-form-wrapper>
